<template>
  <div class="question-view text-drag" >
    <div class="quest" :style="`${mode == 'viewAnswer' ? `--beforeShow: '';` : `--beforeShow: none;`}`">
      <FixedFontSizeSelector>
      <div class="title">
        <vue-mathjax :formula="form.title" @onRenderComplete="onRenderComplete(++mathjaxNum)" :safe="false"/>
      </div>

      <div class="choice-list">
        <div v-drag-text="{self, className: '.input', idx}" :sign="its.content"
        :class="['choice-single', curClickSelect == idx && 'cur-select', alreadyExist.includes(its.content) && 'already-exist']" 
        v-for="(its, idx) in choice" :key="idx" :id="'single' + idx"
        @mousedown="clickEvent($event, idx)">
          <span><vue-mathjax @onRenderComplete="onRenderComplete(++mathjaxNum)" :formula="its.content" :safe="false"/></span>
        </div>
      </div>
      <!-- <div style="height: 500px; width: 100%"></div> -->
      <!-- <div class="m">
        当前坐标: <span class="curZb">curZB</span>
        <br>
        containArea: <span class="containArea">containArea</span>
        <br>
        other: <span class="other">other</span>
      </div> -->
      <div class="question-list">
        <div class="single" :data-id="its.id" v-for="(its, idx) in question" :key="idx">
          <vue-mathjax @onRenderComplete="onRenderComplete(++mathjaxNum)" :formula="its.arr" :safe="false"/>
        </div>
      </div>
      </FixedFontSizeSelector>
    </div>
  </div>
</template>

<script>
import {getNodeOffset} from '@/utils/scroll-to'
import FixedFontSizeSelector from '@/views/student/components/FontSizeSelector'

let dragText = {
  bind(el, binding) {
    // if (window.matchMedia("(max-width: 1080px)").matches) { // 可以根据需要设置不同的断点
    //   mobile(el, binding)
    // } else {
    //   pc(el, binding)
    // }
    mobile(el, binding)
    pc(el, binding)
  }
}

function mobile(el, binding) {
  let isAtBottom = false
  , animationFrameId = null
  // let isDragging = false
  let touchstart = (e) => {
    let { value } = binding,
    {className, self, idx} = value

    let {layerX, layerY, pageX, pageY} = e,
    elPageX = pageX - layerX,
    elPageY = pageY - layerY,
    elWidth = el.offsetWidth,
    elHeight = el.offsetHeight
    console.log(elPageX, elPageY)

    let containers = document.querySelectorAll(className),
    aa = document.querySelector('.body'),
    containIdx = null,
    containArea = []

    // 拖动的时候禁用默认触摸行为
    // aa.style.touchAction = 'none';

    for(let i = 0; i < containers.length; i++) {
      let container = containers[i],
      {left, top} = getNodeOffset(container),
      width = container.offsetWidth,
      height = container.offsetHeight,
      bottom = top + height,
      right = left + width
      containArea.push([left, top, right, bottom])
    }

    let copyEl = el.cloneNode(true)
    copyEl.style = `
      position: absolute;
      top: ${elPageY}px;
      left: ${elPageX}px;
      width: ${elWidth}px;
      height: ${elHeight}px;
      margin: 0 10px 10px 0;
      background-color: #f8ae64;
      border-radius: 8px;
      box-shadow: 1px 2px 2px 1px #ccc;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      user-select: none;
    `
    let img = copyEl.querySelector('img')
    if(img) {
      img.style = `
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        margin: auto;
        height: 100%;
        width: auto;
      `
    }

    document.body.append(copyEl)

    let onTouchMove = (e) => {
      e.preventDefault();

      if(animationFrameId) {
        clearTimeout(animationFrameId);
      }
      // 判断是否到达边界（示例：Y轴底部边界）
      const touch = e.touches[0];
      isAtBottom = (window.innerHeight - touch.clientY) < 50;

      if (isAtBottom) {
        // 到达边界时允许滚动
        const scrollStep = function () {
          // document.querySelector('.other').innerText = `更新: ${Math.random()} - ${isBottom()} - ${aa.scrollTop}`
          if (!isBottom()) {
              // 每次滚动10像素（可调整数值控制速度）
              aa.scrollBy({ top: 100, behavior: 'smooth' });
              
              animationFrameId = setTimeout(scrollStep, 50)
          } else {
              clearTimeout(animationFrameId);
          }
        }

        scrollStep()
      } else {
        pageX = e.pageX
        pageY = e.pageY
        elPageX = pageX - layerX
        elPageY = pageY - layerY
        clearTimeout(animationFrameId);
      }

      copyEl.style.top = `${elPageY}px`
      copyEl.style.left = `${elPageX}px`

      for(let i = 0; i < containArea.length; i++) {
        // Number[4]: left, top, right, bottom
        let item = containArea[i]
        if(pageX >= item[0] 
        && (pageY + aa.scrollTop) >= item[1]
        && pageX <= item[2]
        && (pageY + aa.scrollTop) <= item[3]) {
          containIdx = i
          break;
        } else {
          containIdx = null
        }
      }
    }

    let onTouchEnd = () => {
      // isDragging = false;
      if(containIdx != null) {
        console.log(`第${containIdx}个`)
        console.log(idx)
        self.assignment(idx, containIdx)
      }
      document.body.removeChild(copyEl)
      clearTimeout(animationFrameId);
      document.removeEventListener('touchmove', onTouchMove);
      document.removeEventListener('touchend', onTouchEnd);
    }

    // 动态添加 touchmove 监听（仅在拖动时阻止滚动）
    document.addEventListener('touchmove', onTouchMove, { passive: false });
    document.addEventListener('touchend', onTouchEnd);
  }

  el.addEventListener('touchstart', touchstart)

  // 检测是否滚动到底部
  function isBottom() {
    let element = document.querySelector('.body')
    return element.scrollTop + element.clientHeight >= element.scrollHeight;
  }
}

function pc(el, binding) {
  el.onmousedown = (e) => {
    let { value } = binding,
    {className, self, idx} = value

    let {layerX, layerY, pageX, pageY} = e,
    elPageX = pageX - layerX,
    elPageY = pageY - layerY,
    elWidth = el.offsetWidth,
    elHeight = el.offsetHeight
    console.log(elPageX, elPageY)

    let containers = document.querySelectorAll(className),
    containIdx = null,
    containArea = []

    for(let i = 0; i < containers.length; i++) {
      let container = containers[i],
      {left, top} = getNodeOffset(container),
      width = container.offsetWidth,
      height = container.offsetHeight,
      bottom = top + height,
      right = left + width
      containArea.push([left, top, right, bottom])
    }

    let copyEl = el.cloneNode(true)
    copyEl.style = `
      position: absolute;
      top: ${elPageY}px;
      left: ${elPageX}px;
      width: ${elWidth}px;
      height: ${elHeight}px;
      margin: 0 10px 10px 0;
      background-color: #f8ae64;
      border-radius: 8px;
      box-shadow: 1px 2px 2px 1px #ccc;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      user-select: none;
    `
    let img = copyEl.querySelector('img')
    if(img) {
      img.style = `
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        margin: auto;
        height: 100%;
        width: auto;
      `
    }

    document.body.append(copyEl)

    document.body.onmousemove = (e) => {
      // alert('1')
      let b = document.querySelector('.body')
      pageX = e.pageX - b.scrollLeft
      pageY = e.pageY + b.scrollTop
      elPageX = e.pageX - layerX 
      elPageY = e.pageY - layerY 

      copyEl.style.top = `${elPageY}px`
      copyEl.style.left = `${elPageX}px` 
      //console.clear()
      console.log(pageY)
      for(let i = 0; i < containArea.length; i++) {
        // Number[4]: left, top, right, bottom
        let item = containArea[i]
        console.log(item)
        if(pageX >= item[0] 
        && pageY >= item[1]
        && pageX <= item[2]
        && pageY <= item[3]) {
          containIdx = i
          break;
        } else {
          containIdx = null
        }
      }
    }

    document.body.onmouseup = () => {
      if(containIdx != null) {
        console.log(`第${containIdx}个`)
        console.log(idx)
        self.assignment(idx, containIdx)
      }
      document.body.removeChild(copyEl)
      document.body.onmouseup = null
      document.body.onmousemove = null
    }
  }
}

let pLeft = 'PARENTHESISLEFT', pRight = 'PARENTHESISRIGHT'

export default {
  components: {
    FixedFontSizeSelector
  },
  props: ['form', 'mode'],
  directives: {
    'drag-text': dragText
  },
  data() {
    let letter = new Array(26).fill().map((its, idx) => its = String.fromCharCode(65 + idx))

    return {
      mathjaxNum: 0,

      letter,
      topic: '',
      curClickSelect: null,
      
      choice: [],
      question: [],
      answerNum: 0,
      answer_results: {
        id: null,
        student_choices: []
      },
      recordQuestion: [],
      // 记录已使用的文字选项
      alreadyExist: [],
      self: this,
      // 记录答题次数
      limit: 0
    }
  },
  watch: {
    'form.id': {
      handler() {
        this.initData()
      },
      deep: true
    }
  },
  methods: {
    findImageLinks(text) {
      // 匹配常见的图片链接格式，如 .jpg, .jpeg, .png, .gif 等
      const regex = /(https?:\/\/.*?\.(?:png|jpg|jpeg|gif))/gi;
      let match;
      const imageLinks = [];

      // 使用正则表达式在文本中查找匹配的图片链接
      while ((match = regex.exec(text)) !== null) {
          imageLinks.push(match[0]);
      }

      return imageLinks;
    },
    onRenderComplete(i) {
      let num = 1 + this.choice.length + this.question.length
      
      if(i == num) {
        this.$parent.loading = false
      }
    },
    // 重置
    resetting() {
      this.$emit('permissions', false)
      this.limit = 0

      // 样式清空
      let blocks = document.querySelectorAll('.question-list .single .input')
      for(let i = 0; i < blocks.length; i++) {
        blocks[i].innerHTML = ''
        blocks[i].dataset.value = ''
      }
    
      this.recordQuestion = []
      this.alreadyExist = []
      this.answer_results = {
        id: null,
        student_choices: []
      }
      this.repariRecordQuestion()
    },
    repariRecordQuestion() {
      this.$emit('repariRecordQuestion', this.recordQuestion, this.limit)
    },
    showTrueFalse() {
      let { form, recordQuestion } = this, answers = {},
      blocks = document.querySelectorAll('.question-list .single')
      console.log(recordQuestion)
      if(recordQuestion.length == 0) {
        return ;
      }

      this.limit = 1

      form.answers.filter((its, idx) => {
        if(idx != form.answers.length - 1) {
          answers[its.choice_id] = JSON.parse(its.value)
        }
      })

      for(let i = 0; i < blocks.length; i++) {
        let block = blocks[i],
        id = block.dataset.id,
        childs = block.querySelectorAll('.input')
        console.log(recordQuestion[id])
        for(let j = 0; j < childs.length; j++) {
          let {value, } = recordQuestion[id][j]
          console.log(childs[j])
          // console.log(html)
          // 回显答案
          // 判断图片链接还是文本
          let [img] = this.findImageLinks(value)
          if(img) {
            childs[j].innerHTML = `<img src="${img}" />`
          } else {
            // 过滤拖拽选项
            let [cur] = Array.from(document.querySelectorAll('.choice-single')).filter(its => its.getAttribute('sign') == value)

            if(cur) {
              childs[j].innerHTML = cur.innerHTML
            } else childs[j].innerHTML = value || ''
          }
          childs[j].dataset.value = value || ''

          if(this.mode == 'question') {
            continue ;
          }
          // 回显对错
          if(answers[id][j] == value) {
            childs[j].classList.add('determine-success-br')
          } else {
            childs[j].classList.add('determine-error-br')
          }
        }
      }
    },
    dragStart(e, idx) {
      e.dataTransfer.setData('textDragMsg', idx)
      //alert('1')
    },
    clickEvent(e, idx) {
      this.curClickSelect = idx
    },
    dragover(e) {
      e.preventDefault()
    },

    drop(e) {
      let textDragMsg = e.dataTransfer.getData('textDragMsg')
      
      this.assignment(e, textDragMsg)
    },

    // 填空区域点击事件
    clickFillEare(e, i) {
      if(this.curClickSelect != null) {
        let textDragMsg = this.curClickSelect
        this.assignment(textDragMsg, i)
      } else {
        // 存在 e.target 为子节点  不是「填空区域」获取父节点后再作处理
        let eareBox = e.target.classList.contains('input') ? e.target : e.target.parentNode
        eareBox.innerText = ''
        eareBox.dataset.value = ''

        this.saveAnswers()
        // // 是否满足下一题的条件
        // let inputs = document.querySelectorAll('.input > span'),
        // num = 0
        // for(let i = 0; i < inputs.length; i++) {
        //   if(inputs[i].innerText != '') {
        //     num ++
        //   }
        // }
        // console.log(this.answerNum, num)
        // if(num > 0) {
        //   this.$emit('permissions', true)
        //   this.limit = num
        // }
        // // if(this.answerNum == num) this.$emit('permissions', true)
        // else {
        //   this.$emit('permissions', false)
        //   this.limit = 0
        // }
      }
    },
    assignment(textDragMsg, containIdx) {
      console.log('assignment ------------- ')
      // 存在 e.target 为子节点  不是「填空区域」获取父节点后再作处理
      let eareBox = document.querySelectorAll('.input')[containIdx]
      // 获取拖拽的节点
      let dragNode = document.querySelector('#single' + textDragMsg)
      console.log(textDragMsg)
      console.log(dragNode)
      console.log(containIdx)
      console.log(eareBox)
      eareBox.innerHTML = dragNode.innerHTML

      /// 判断拖动的元素是图片 还是文本
      let content = this.choice[textDragMsg].content
      console.log(content)
      // if(content.indexOf('<img src=') > -1) {
      //   let [img] = this.findImageLinks(content)
      //   content = img
      // }
      eareBox.dataset.value = content
      console.log(content)
      console.log(eareBox)

      this.saveAnswers()
    },
    changeChoice(content) {
      content = content.replaceAll('\\left(', pLeft).replaceAll('\\right)', pRight)
      // let regex = /\(\)/g, 
      let regex = /\$\$([^$]*)\$\$|\$([^$]*)\$/g,
      regex1 = /@(.*?)#/g,
      // regex1 = /(?<!\\left)(?<!\\right)\(([^()]*)\)/g,
      regexMap = {
        over: /\$(([^$]*)\\over([^$]*))\$/,
        frac: /\$(([^$]*)\\frac([^$]*))\$/
      }, res, grade, arr = []
      // , subscript = 0

      res = content.match(regex1)
      grade = content.match(regex)
      if(grade) {
        for(let i = 0; i < grade.length; i++) {
          let its = grade[i],
          over = its.match(regexMap.over),
          frac = its.match(regexMap.frac)
          // 分数结构
          if(over) {
            // 处理數据 判断是否被()括住
            for(let i = 2; i < over.length; i++) {
              let val = over[i].match(regex1)
              // 在替换之前将 \left(, \right) 转为()
              over[i] = over[i].replaceAll('\\left(', '(').replaceAll('\\right)', ')')
           
              if(val) {
                let constVal = over[i].split('()')
                over[i] = {fill: true, val: constVal}
              }
              else over[i] = {fill: false, val: over[i]}
            }

            // 判断fill 是否为true
            let isFill = over.some(its => its.fill)
            if(!isFill) {
              continue ;
            }

            let [, , child, parent] = over

            arr.push(...[
              { text: '', answerArea: true, type: 'decimals', map: [
                  child, parent
                ]
              }, 
            ])
            this.answerNum++
            let echoHtml = `
            <div class="some-as">
              ${ child.fill ? 
                  `
                  <div class="some-child">
                    ${
                      child.val.map((ele, idx) => {
                        if(idx == 0) {
                          return `<span>${ele}</span>`
                        } else {
                          return `<div class="input">
                          </div>
                          <span>${ele}</span>
                          `
                        }
                      }).join('')
                    }
                  </div>
                  ` :
                  `<div class="numerator">${child.val}</div>` }
              ${ parent.fill ? 
                  `
                  <div class="some-child">
                    ${
                      parent.val.map((ele, idx) => {
                        if(idx == 0) {
                          return `<span>${ele}</span>`
                        } else {
                          return `<div class="input">
                          </div>
                          <span>${ele}</span>
                          `
                        }
                      }).join('')
                    }
                  </div>
                  ` :
                  `<div class="denominator">${parent.val}</div>` }
            </div>
            `
            content = content.replace(its, echoHtml)
          }
          // 带分数结构
          if(frac) {
            // integer 整数部分，fraction 分数部分
            let [, , integer, fraction] = frac
            , fractionRegex = /\{.*?\}/g
            // 取出同时去除首尾的大括号
            , [child, parent] = fraction.match(fractionRegex)
                              .map(s => s.slice(1, -1))
            
            let echoData = [integer, child, parent]
            // 处理數据 判断是否被()括住
            for(let i = 0; i < echoData.length; i++) {
              let val = echoData[i].match(regex1)
              // 在替换之前将 \left(, \right) 转为()
              echoData[i] = echoData[i].replaceAll('\\left(', '(').replaceAll('\\right)', ')')
              
              if(val) {
                let constVal = echoData[i].split('()')
                echoData[i] = {fill: true, val: constVal}
              } else echoData[i] = {fill: false, val: echoData[i]}
            }

            // 判断fill 是否为true
            let isFill = echoData.some(its => its.fill)
            if(!isFill) {
              continue ;
            }
            this.answerNum++
            let echoHtml = `
            <div class="mixed-number">
              ${ echoData[0].fill ? 
                  `
                  <div class="some-child">
                    ${
                      echoData[0].val.map((ele, idx) => {
                        if(idx == 0) {
                          return `<span>${ele}</span>`
                        } else {
                          return `<div class="input">
                          </div>
                          <span>${ele}</span>
                          `
                        }
                      }).join('')
                    }
                  </div>
                  `:
                  `<div class="mixed">${echoData[0].val}</div>` }
              <div class="some-as">
                ${ echoData[1].fill ? 
                  `
                  <div class="some-child">
                    ${
                      echoData[1].val.map((ele, idx) => {
                        if(idx == 0) {
                          return `<span>${ele}</span>`
                        } else {
                          return `<div class="input">
                          </div>
                          <span>${ele}</span>
                          `
                        }
                      }).join('')
                    }
                  </div>
                  `:
                  `<div class="numerator">${echoData[1].val}</div>` }
  
                ${ echoData[2].fill ? 
                  `
                  <div class="some-child">
                    ${
                      echoData[2].val.map((ele, idx) => {
                        if(idx == 0) {
                          return `<span>${ele}</span>`
                        } else {
                          return `<div class="input">
                          </div>
                          <span>${ele}</span>
                          `
                        }
                      }).join('')
                    }
                  </div>
                  ` :
                  `<div class="denominator">${echoData[2].val}</div>` }
              </div>
            </div>
            `
            content = content.replace(its, echoHtml)
          }
        }
      }

      if(res) {
        for(let i = 0; i < res.length; i++) {
          this.answerNum++
          let echoHtml = `
          <div class="input">
          </div>`
          content = content.replace(res[i], echoHtml)
        }
      }

      // content = content.replaceAll('\\left(', '(').replaceAll('\\right)', ')')
      content = content.replaceAll(pLeft, '(').replaceAll(pRight, ')')
      return `<div class="single-flex">${content}</div>`
    },
    saveAnswers() {
      // 保存答案
      let singles = document.querySelectorAll('.single'),
      answerMap = {}
      console.log(singles)
      let recordQuestion = {}
      // 重置数据
      this.alreadyExist = []
      for(let i = 0; i < singles.length; i++) {
        let single = singles[i],
        id = single.dataset.id,
        values = single.querySelectorAll('.input')
        console.log(values)
  
        for(let j = 0; j < values.length; j++) {
          let val = values[j],
          value = val.dataset.value
          this.alreadyExist.push(value)
          console.log('-------- val ')
          console.log(val, val.innerHTML)
          if(answerMap[id]) {
            answerMap[id].push(value)
            recordQuestion[Number(id)].push({
              value, 
              html: val.innerHTML
            })
          } else {
            answerMap[id] = [value]
            recordQuestion[Number(id)] = [{
              value, 
              html: val.innerHTML
            }]
          }
        }
      }
  
      this.answer_results.student_choices = []
      this.recordQuestion = recordQuestion
      console.log('recordQuestion')
      console.log(recordQuestion)
      for(let key in answerMap) {
        this.answer_results.student_choices.push({choice_id: Number(key), value: JSON.stringify(answerMap[key])})
      }
      this.form.choices.filter(its => {
        if(!its.value.match(/@#/g)) {
          this.answer_results.student_choices.push({choice_id: Number(its.id), value: JSON.stringify([])})
        }
      })
      console.log(this.answer_results.student_choices)
      // 是否满足下一题的条件
      let inputs = document.querySelectorAll('.input'),
      num = 0

      for(let i = 0; i < inputs.length; i++) {
        console.log(inputs[i], inputs[i].innerText)
        if(inputs[i].innerHTML.trim() != '') {
          num ++
        }
      }
      console.log(this.answerNum, num)
      if(num > 0) {
        this.$emit('permissions', true)
        this.limit = num
      }
      // if(this.answerNum == num) this.$emit('permissions', true)
      else {
        this.$emit('permissions', false)
        this.limit = 0
      }
  
      this.curClickSelect = null

    },
    initData() {
      this.answer_results = {
        id: null,
        student_choices: []
      }
      this.recordQuestion = []
      this.choice = []
      this.question = []
      this.answerNum = 0

      let content = JSON.parse(this.form.content)
      console.log(content)
      let deWeight = []
      this.choice = JSON.parse(JSON.stringify(content.choice)).filter(its => {
        /// 匹配出图片链接，并赋予标签
        let imgs = this.findImageLinks(its.content)
        for(let i = 0; i < imgs.length; i++) {
          let imgDomStr = `<img src="${imgs[i]}" />`
          its.content = its.content.replace(imgs[i], imgDomStr)
        }

        if(!deWeight.includes(its.content)) {
          deWeight.push(its.content)
        } else {
          return false
        }
        
        return its.content && its
      })

      console.log('this.choice')
      console.log(deWeight)
      console.log(this.choice)
      // 去重
      this.choice = [...new Set(this.choice)]

      for(let i = 0; i < this.choice.length; i++) {
        let randomNum = Math.floor(Math.random() * this.choice.length);
        [this.choice[i], this.choice[randomNum]] = [this.choice[randomNum], this.choice[i]]
      }

      this.question = JSON.parse(JSON.stringify(this.form.choices)).filter(its => {
        /// 匹配出图片链接，并赋予标签
        let imgs = this.findImageLinks(its.value)
        for(let i = 0; i < imgs.length; i++) {
          let imgDomStr = `<img src="${imgs[i]}" class="text-img" />`
          its.value = its.value.replace(imgs[i], imgDomStr)
        }
        
        return its.value && its
      })
      .map(its => {
        // 还原答案
        return {id: its.id, arr: this.changeChoice(its.value)}
      })
      console.log(this.question)
      this.$nextTick(() => {
        if(this.mode == 'question') {
          let doms = document.querySelectorAll('.text-drag .input') 
  
          for(let i = 0; i < doms.length; i++) {
            doms[i].onclick = (e) => {
              console.log('click')
              this.clickFillEare(e, i)
            }
            doms[i].ontap = (e) => {
              console.log('ontap')
              this.clickFillEare(e, i)
            }
            doms[i].ondrop = (e) => this.drop(e)
            doms[i].ondragover = this.dragover
          }

        }

      })
      // this.question.filter(its => {
      //   its.arr.filter(item => item.answerArea && this.answerNum++)
      // })
      setTimeout(() => {
        this.showTrueFalse()
        this.saveAnswers()
      }, 1000)
    }
  },
  created() {
    this.initData()
  }
}
</script>

<style scoped lang="scss">
@import url('../../static/pubile.scss');

.question-view {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 10px;
  
  .quest {
    width: 100%;
    height: 100%;

    .title {
      font-size: 15px;
      color: #333;
    }
    .choice-list {
      margin-top: 20px;
      display: flex;
      justify-content: flex-start;
      align-content: flex-start;
      flex-wrap: wrap;

      .choice-single {
        padding: 0 5px;
        box-sizing: border-box;
        min-width: 100px;
        height: 40px;
        margin: 0 10px 10px 0;
        background-color: #f8ae64;
        border-radius: 8px;
        box-shadow: 1px 2px 2px 1px #ccc;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        user-select: none;

        &:hover {
          opacity: .8;
        }
      }

      .cur-select {
        box-shadow: 0px 0px 10px 2px orange;
      }

      .already-exist {
        background-color: #c0c4cc !important;
      }
    }
    .question-list {
      margin-top: 20px;
      width: 100%;
      padding: 0;
      overflow-x: auto;

      .single {
        width: 80%;
        // height: 32px;
        padding: 0 10px;
        box-sizing: border-box;
        border-radius: 10px;
        // border: 2px solid #fcd2ab;
        // background-color: #fcd2ab;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 10px;
        cursor: pointer;

        .single-letter {
          font-size: 15px;
          // font-weight: 700;
          margin-right: 5px;
        }

        .single-cte {
          font-size: 14px;
          letter-spacing: 1px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin-bottom: 5px;

          .input {
            min-width: 100px;
            height: 30px;
            background-color: #fcd2ab;
            border-radius: 10px;
            padding: 0 10px;
            box-sizing: border-box;
            outline: none;
            border: none;
            margin: 0 10px;
            display: flex;
            align-items: center;
            position: relative;
            .mask {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              // z-index: 99;
              cursor: pointer;
            }

            span {
              position: absolute;
              display: flex;
              width: 100%;
              height: 100%;
              left: 0;
              justify-content: center;
              align-items: center;
              // z-index: 99;
            }

            .success, .error {
              position: absolute;
              bottom: -4px;
              right: -4px;
              width: 12px;
              height: 12px;
              border-radius: 50%;
              background-color: #007416;
              display: none;
            }
            .success {
              &:before {
                content: '';
                color: #fff;
                position: absolute;
                top: -3px;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                width: 7px;
                height: 4px;
                border: 2px solid #fff;
                border-top: none;
                border-right: none;
                transform: rotateZ(-50deg);
                transform-origin: center center;
              }
            }

            .error {
              background-color: #d60215;

              &:before, &:after {
                content: '';
                width: 8px;
                height: 2px;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                transform: rotateZ(-45deg);
                transform-origin: center center;
                background-color: #fff;
              }

              &:after {
                transform: rotateZ(45deg);
              }
            }
          }

          .input-success {
            &:before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              border: 1px solid #007416;
              border-radius: 10px;
            }
          }
          .input-error {
            &:before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              border: 1px solid #d60215;
              border-radius: 10px;
            }
          }
        }

        &:hover {
          opacity: .8;
        }
      }

      .single-select {
        border-color: #d37525;
        background-color: #f8ae64;
      }
    }

  }

}
</style>

<style lang="scss">
.question-view.text-drag {

  img {
    user-select: none;
  }

  .choice-single {
    position: relative;
    img {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin: auto;
      height: 100%;
      width: auto;
    }
  }
  .single-flex {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .text-img, img {
      width: auto;
      height: 50px;
      margin: 0 5px;
    }
    .input {
      min-width: 100px;
      height: 40px;
      background-color: #fcd2ab;
      border-radius: 10px;
      padding: 0 10px;
      box-sizing: border-box;
      outline: none;
      border: none;
      margin: 0 10px;
      display: flex;
      align-items: center;
      position: relative;
      justify-content: center;
      position: relative;
      margin-bottom: 1px;

      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 2;
      }

      & > span {
        display: flex;
        justify-content: center;
      }

      img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        margin: auto;
        height: 100%;
        width: auto;
      }
    }
  
    .some-as {
      display: inline-block;
      margin: 0 5px;
      position: relative;
      color: #333;
      vertical-align: middle;
  
      &:after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        height: 1px;
        width: 100%;
        background-color: #333;
      }
  
      .some-child {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 8px 0;
        height: 40px;
        
        & > span {
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .numerator, .denominator {
        margin: 8px 0;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 40px;
      }
  
      .numerator.fill, .denominator.fill {
        border-radius: 10px;
        background-color: #fcd2ab;
        outline: none;
        border: none;
        width: 60px;
        text-align: center;
        padding: 5px;
        box-sizing: border-box;
      }
    }
  
    .mixed-number {
      display: inline-flex;
      align-items: center;
      .mixed {
        color: #333;
      }
  
      .mixed.fill {
        border-radius: 10px;
        background-color: #fcd2ab;
        outline: none;
        border: none;
        width: 60px;
        height: 40px;
        text-align: center;
        padding: 5px;
        color: #333;
      }
    } 
  }

}
</style>